import { styled } from 'styled-components';
import { hexToRGB } from '@/styles/helpers';

export const ScHorizontalCountdown = styled.div`
  border-radius: 8px;
  display: flex;
  column-gap: 8px;
  flex-wrap: nowrap;
  align-items: center;

  & .label {
    position: relative;
    font-size: 14px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0.4px;
    text-transform: capitalize;
    white-space: pre-line;
    color: ${({ theme }) => theme.whiteColor};
  }

  & .countdown {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 20px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0.6px;
    font-variant-numeric: tabular-nums;
    display: flex;
    column-gap: 2px;

    span {
      position: relative;
      display: inline-block;
      padding-bottom: 10px;
      text-align: center;

      &::before {
        position: absolute;
        display: block;
        content: attr(attr-label);
        font-size: 10px;
        font-weight: 400;
        line-height: 100%;
        white-space: nowrap;
        left: 50%;
        transform: translateX(-50%);
        text-transform: lowercase;
        bottom: 0;
        font-weight: 400;
        color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
      }
    }
  }
`;
